import api from '@/api/axiosApi'
import type { ExportRead } from '@/types'
import type { CreateExportResponse } from '@/hooks/useExport'

export interface CreateQuoteSheetRequest {
  line_item_ids: string[]
  type: 'domestic' | 'import'
}

/**
 * Create a new quote sheet export job
 * POST /plans/{planId}/versions/{versionId}/lines/quote-sheets
 */
export async function createQuoteSheet(
  planId: string,
  versionId: string,
  request: CreateQuoteSheetRequest
): Promise<CreateExportResponse> {
  const response = await api.post<CreateExportResponse>(
    `/plans/${planId}/versions/${versionId}/lines/quote-sheets`,
    request
  )
  return response.data
}

/**
 * Get quote sheet export status and download URL
 * GET /exports/{exportId}
 */
export async function getQuoteSheet(exportId: string): Promise<ExportRead> {
  const response = await api.get<ExportRead>(`/exports/${exportId}`)
  return response.data
}
